import React, { useState, useEffect } from "react";
import { Package, ScrollText, AlertTriangle, DollarSign, Tag } from "lucide-react";
import { formatCurrency, fetchExchangeRates } from "../utils/currencyUtils"; 
import axios from "../api/api";
import { useDispatch, useSelector } from "react-redux";

const ShippingProductDisplay = ({ product, state, invalidProducts }) => {
  const calculateDiscountedPrice = (price, discount) => {
    return price - (price * discount) / 100;
  };
  const [currencyCode, setCurrencyCode] = useState("NGN");
  const [exchangeLoaded, setExchangeLoaded] = useState(false);
  const { userInfo } = useSelector((state) => state.auth);
  useEffect(() => {
    fetchExchangeRates().then(() => setExchangeLoaded(true));
  }, []);
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const { data } = await axios.get("/account/get-details", {
          withCredentials: true,
        });
        // if (data.currency) {
        //   setCurrencyCode(data.currency);
        // }
      } catch (error) {
      
      }
    };

    if (userInfo && userInfo.id) {
      fetchUserDetails();
    }
  }, []);
  return (
    <div className="w-full flex flex-col mt-2">
      <div className="flex sm:w-full gap-2">
        <div className="flex gap-2 justify-start items-center w-full">
          <img
            className="w-[80px] h-[80px] nex_img_cover rounded-sm"
            src={product.productInfo.images[0]}
            alt="product image"
          />
          <div className="px-2 text-[var(--store-text)] flex-grow">
            <div className="flex justify-between items-start">
              <div>
                <h2 className="text-md">{product.productInfo.name}</h2>
                <span className="text-sm">
                  Brand: {product.productInfo.brand}
                </span>
                <div className="text-sm mt-1">
                  Quantity: {product.quantity}
                </div>
              </div>
              <div className="flex flex-col items-end">
                <div className="flex items-center gap-2">
                  {product.productInfo.discount > 0 && (
                    <span className="text-sm line-through text-[var(--store-muted)]">
                      {formatCurrency(product.productInfo.price, currencyCode, product.productInfo.currency)}
                    </span>
                  )}
                  <div className="flex items-center text-[var(--store-accent)]">
                    <span className="font-semibold">
                      {formatCurrency(calculateDiscountedPrice(
                        product.productInfo.price,
                        product.productInfo.discount
                      ), currencyCode, product.productInfo.currency)}
                    </span>
                  </div>
                </div>
                {product.productInfo.discount > 0 && (
                  <div className="flex items-center text-green-500 text-sm mt-1">
                    <Tag size={14} className="mr-1" />
                    {product.productInfo.discount}% off
                  </div>
                )}
                {state.country && (product.productInfo.shippingPrices?.[state.country] !== undefined && product.productInfo.shippingPrices?.[state.country] !== "") && (
                  <div className="text-sm text-[var(--store-muted)] mt-1">
                    {Number(product.productInfo.shippingPrices[state.country]) === 0 ? (
                      <span className="text-green-500 font-medium">Free Shipping</span>
                    ) : (
                      `+${formatCurrency(product.productInfo.shippingPrices[state.country], currencyCode, product.productInfo.currency)} shipping`
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {state.country &&
        invalidProducts.includes(product.productInfo._id) && (
          <div className="mt-2 p-3 border border-red-500 rounded-md bg-red-500/10">
            <div className="flex items-center gap-2 text-red-500">
              <AlertTriangle className="h-4 w-4" />
              <p className="text-sm">
                This product does not ship to {state.country}.
                Please remove it from your cart to continue.
              </p>
            </div>
          </div>
        )}
    </div>
  );
};

export default ShippingProductDisplay;